module.exports = __webpack_public_path__ + "static/media/ambient.1d957836.mp3";